import React, { useEffect } from "react";
import { languages } from "../constants/languages";
import DefaultBackground from "../constants/DefaultBackground";

/** Tournify mark (same geometry as public/favicon.svg light theme), solid brand blue */
const TournifyLogoMark = () => (
  <svg
    width="72"
    height="72"
    viewBox="0 0 1024 1024"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Tournify"
    style={{ display: "block" }}
  >
    <path
      d="M682.992 364H8.95034C2.06324 364 -2.22993 356.51 1.21362 350.546L161.987 71.7272C164.402 67.5563 168.83 65 173.615 65H510.635C663.896 65 759.644 231.116 683.037 364H682.992Z"
      fill="#3311FF"
    />
    <path
      d="M861.485 77.4492C858.042 71.5169 849.457 71.5169 846.014 77.4492L681.375 361.485L509 658.813C585.641 791.062 777.064 791.062 853.704 658.813L1022.19 368.176C1024.6 364.028 1024.6 358.943 1022.19 354.795L861.44 77.4939L861.485 77.4492Z"
      fill="#3311FF"
    />
    <path
      d="M672.743 944.635L336.098 364C183.053 364 87.4115 528.972 163.934 660.977L332.256 951.317C334.668 955.461 339.091 958 343.871 958H665.059C671.939 958 676.227 950.56 672.788 944.635H672.743Z"
      fill="#3311FF"
    />
  </svg>
);

const CTA_BLUE = "#3311FF";

/** Main marketing site (tournifyURL points at /events) */
function tournifyMainSiteURL() {
  return String(languages.tournifyURL || "").replace(/\/events\/?$/, "");
}

export const Error404 = () => {
  useEffect(() => {
    const previous = document.body.style.background;
    document.body.style.background = "#ffffff";
    return () => {
      document.body.style.background = previous || DefaultBackground;
    };
  }, []);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "clamp(24px, 5vw, 48px)",
        boxSizing: "border-box",
        backgroundColor: "#ffffff",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          maxWidth: "520px",
          width: "100%",
        }}
      >
        <div style={{ marginBottom: "24px" }}>
          <TournifyLogoMark />
        </div>
        <h1
          style={{
            margin: 0,
            fontFamily: "'Soehne Breit', sans-serif",
            fontWeight: 400,
            fontSize: "clamp(1.35rem, 4vw, 1.75rem)",
            lineHeight: 1.35,
            color: "#0a1628",
            letterSpacing: "normal",
          }}
        >
          {languages.tournament404Heading}
        </h1>
        <p
          style={{
            margin: "16px 0 0",
            fontSize: "clamp(1rem, 2.5vw, 1.125rem)",
            fontWeight: 400,
            lineHeight: 1.55,
            color: "#5a6b7d",
          }}
        >
          {languages.tournament404Subtext}
        </p>
        <div
          style={{
            marginTop: "36px",
            display: "flex",
            flexWrap: "wrap",
            gap: "12px",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          }}
        >
          <a
            href={languages.tournifyURL}
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "14px 32px",
              borderRadius: "9999px",
              backgroundColor: CTA_BLUE,
              color: "#ffffff",
              fontSize: "1rem",
              fontWeight: 600,
              textDecoration: "none",
              textAlign: "center",
              transition: "background-color 0.15s ease",
              boxShadow: "0 1px 2px rgba(51, 17, 255, 0.25)",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#2a0dcc";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = CTA_BLUE;
            }}
            onFocus={(e) => {
              e.currentTarget.style.outline = "2px solid #3311FF";
              e.currentTarget.style.outlineOffset = "3px";
            }}
            onBlur={(e) => {
              e.currentTarget.style.outline = "none";
              e.currentTarget.style.outlineOffset = "0";
            }}
          >
            {languages.searchTournaments}
          </a>
          <a
            href={tournifyMainSiteURL()}
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "14px 32px",
              borderRadius: "9999px",
              backgroundColor: "#ffffff",
              color: "#0a1628",
              fontSize: "1rem",
              fontWeight: 600,
              textDecoration: "none",
              textAlign: "center",
              border: "1px solid #d1d9e3",
              transition: "background-color 0.15s ease, border-color 0.15s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#f4f6f9";
              e.currentTarget.style.borderColor = "#b8c4d4";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffffff";
              e.currentTarget.style.borderColor = "#d1d9e3";
            }}
            onFocus={(e) => {
              e.currentTarget.style.outline = "2px solid #3311FF";
              e.currentTarget.style.outlineOffset = "3px";
            }}
            onBlur={(e) => {
              e.currentTarget.style.outline = "none";
              e.currentTarget.style.outlineOffset = "0";
            }}
          >
            {languages.goToHomepage}
          </a>
        </div>
      </div>
    </div>
  );
};
